import { render, staticRenderFns } from "./ShelveModifyPopup.vue?vue&type=template&id=4c38429c"
import script from "./ShelveModifyPopup.vue?vue&type=script&lang=js"
export * from "./ShelveModifyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports